import { Box, Group, Text } from '@mantine/core';
import { IconCheck, IconHourglassEmpty, IconX } from '@tabler/icons-react';
import React from 'react';

const MaterialInputStatus = ({ item }: { item: { status: string } }) => {
  const status = item.status.toLowerCase();

  const backgroundColor = status === 'pending' ? 'blue' : status === 'approved' ? 'green' : 'red';

  const icon = () => {
    if (status === 'pending') {
      return <IconHourglassEmpty color='white' size={16} />;
    }
    if (status === 'approved') {
      return <IconCheck color='white' size={16} />;
    }
    return <IconX color='white' size={16} />;
  };

  return (
    <Group gap={2} wrap='nowrap'>
      <Box
        w={24}
        h={24}
        style={{
          borderRadius: '50%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
        bg={backgroundColor}
      >
        {icon()}
      </Box>
      <Text fw={600} fz={12} c={'dark'}>
        {item.status}
      </Text>
    </Group>
  );
};

export default MaterialInputStatus;
